import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { ButtonIcon } from '../icon';
import { toggleDrawer } from './actions';

const DrawerToggler = connect(
  ({ drawer }) => ({
    isExpanded: drawer.expanded,
  }),
  dispatch => ({
    toggle: () => dispatch(toggleDrawer()),
  }),
)(({ isExpanded, toggle }) => (
  <ButtonIcon
    onClick={toggle}
    onKeyPress={toggle}
    className={classnames(
      'mdc-toolbar__menu-icon',
      'drawer-toggle-button',
      { active: isExpanded },
    )}
  >menu
  </ButtonIcon>
));

export default DrawerToggler;
